import React, { useRef, useEffect } from "react";
import Head from "next/head";
import Image from "next/image";
import NextLink from "next/link";

import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";

import BlogGraphic1 from "../../../public/blog_graphics/contour_guide_graphic.png";
import BlogGraphic2 from "../../../public/blog_graphics/face_shape_graphic.png";

const HomePage = () => {
  return (
    <>
      <Head>
        <title>Blog | StyleSense.io</title>
        <meta
          name="description"
          content="StyleSense.io is a personalized beauty platform that helps you discover your unique features and find the best style for you. Read our blog to learn more about our tools."
          key="desc"
        />
      </Head>
      <main className="min-h-screen flex flex-col justify-between items-center">
        <Navbar />
        <div>
          <div class="w-full py-16 pb-0 text-center max-w-3xl mx-auto mb-8 px-4 md:px-0">
            <h2 class="text-lg font-bold text-rose-500">Blogs</h2>{" "}
            <p class="mt-6 text-3xl font-medium lg:leading-[54px] tracking-tight sm:text-4xl lg:text-5xl text-primary-500">
              Latest articles and learning resources
            </p>{" "}
            <p class="mt-4 text-base font-normal text-gray-600 dark:text-gray-200">
              Insights, ideas, and inspiration for personalized beauty
            </p>
          </div>
          <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
            <div className="grid max-w-md grid-cols-1 mx-auto mt-12 sm:mt-16 md:grid-cols-3 gap-y-12 md:gap-x-8 lg:gap-x-16 md:max-w-none">
            <div class="group">
                {/* <div class="relative">
                  <NextLink
                    href="/blog/contour-for-face-shape-how-to"
                    class=""
                    title=""
                  >
                    <div class="block overflow-hidden aspect-w-16 aspect-h-9 rounded-xl">
                      <Image
                        src={BlogGraphic1}
                        alt=""
                        className="object-cover w-full h-full transition-all duration-200 transform group-hover:scale-110 rounded-xl"
                      />
                    </div>
                  </NextLink>
                </div> */}
                <p class="mt-6 text-sm font-medium text-gray-500 dark:text-gray-100">
                  November 21, 2024
                </p>
                <p class="mt-4 text-xl font-bold leading-tight text-gray-900 dark:text-gray-50 xl:pr-8">
                  <NextLink
                    href="/blog/optimize-style-ai-with-ab-testing"                    
                    class=""
                    title=""
                  >
                    How We Optimize Style AI Recommendations with A/B Testing | Behind the Tech Scenes
                  </NextLink>
                </p>{" "}
                <div class="mt-6">
                  <NextLink
                    href="/blog/optimize-style-ai-with-ab-testing"                    
                    class="inline-flex items-center pb-2 text-xs font-bold tracking-widest text-gray-900 dark:text-gray-50 uppercase border-b border-gray-900 group dark:border-gray-50"
                    title=""
                  >
                    Continue Reading
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                      class="text-gray-900 dark:text-gray-50 w-4 h-4 ml-2 transition-all duration-200 transform group-hover:translate-x-1"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      ></path>
                    </svg>
                  </NextLink>
                </div>
              </div>                   
              <div class="group">
                {/* <div class="relative">
                  <NextLink
                    href="/blog/contour-for-face-shape-how-to"
                    class=""
                    title=""
                  >
                    <div class="block overflow-hidden aspect-w-16 aspect-h-9 rounded-xl">
                      <Image
                        src={BlogGraphic1}
                        alt=""
                        className="object-cover w-full h-full transition-all duration-200 transform group-hover:scale-110 rounded-xl"
                      />
                    </div>
                  </NextLink>
                </div> */}
                <p class="mt-6 text-sm font-medium text-gray-500 dark:text-gray-100">
                  July 21, 2024
                </p>
                <p class="mt-4 text-xl font-bold leading-tight text-gray-900 dark:text-gray-50 xl:pr-8">
                  <NextLink
                    href="/blog/global-beauty-secrets-revealed"                    
                    class=""
                    title=""
                  >
                    Global Beauty Secrets You May Not Know About | Unveiling Beauty Rituals
                  </NextLink>
                </p>{" "}
                <div class="mt-6">
                  <NextLink
                    href="/blog/global-beauty-secrets-revealed"                    
                    class="inline-flex items-center pb-2 text-xs font-bold tracking-widest text-gray-900 dark:text-gray-50 uppercase border-b border-gray-900 group dark:border-gray-50"
                    title=""
                  >
                    Continue Reading
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                      class="text-gray-900 dark:text-gray-50 w-4 h-4 ml-2 transition-all duration-200 transform group-hover:translate-x-1"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      ></path>
                    </svg>
                  </NextLink>
                </div>
              </div>               
              <div class="group">
                <div class="relative">
                  <NextLink
                    href="/blog/contour-for-face-shape-how-to"
                    class=""
                    title=""
                  >
                    <div class="block overflow-hidden aspect-w-16 aspect-h-9 rounded-xl">
                      <Image
                        src={BlogGraphic1}
                        alt=""
                        className="object-cover w-full h-full transition-all duration-200 transform group-hover:scale-110 rounded-xl"
                      />
                    </div>
                  </NextLink>
                </div>
                <p class="mt-6 text-sm font-medium text-gray-500 dark:text-gray-100">
                  August 21, 2023
                </p>
                <p class="mt-4 text-xl font-bold leading-tight text-gray-900 dark:text-gray-50 xl:pr-8">
                  <NextLink
                    href="/blog/contour-for-face-shape-how-to"                    
                    class=""
                    title=""
                  >
                    Contour for Your Face Shape | How to Highlight Your Features
                  </NextLink>
                </p>{" "}
                <div class="mt-6">
                  <NextLink
                    href="/blog/contour-for-face-shape-how-to"
                    class="inline-flex items-center pb-2 text-xs font-bold tracking-widest text-gray-900 dark:text-gray-50 uppercase border-b border-gray-900 group dark:border-gray-50"
                    title=""
                  >
                    Continue Reading
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                      class="text-gray-900 dark:text-gray-50 w-4 h-4 ml-2 transition-all duration-200 transform group-hover:translate-x-1"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      ></path>
                    </svg>
                  </NextLink>
                </div>
              </div>              
              <div class="group">
                <div class="relative">
                  <NextLink
                    href="/blog/understanding-different-face-shapes"
                    class=""
                    title=""
                  >
                    <div class="block overflow-hidden aspect-w-16 aspect-h-9 rounded-xl">
                      <Image
                        src={BlogGraphic2}
                        alt=""
                        className="object-cover w-full h-full transition-all duration-200 transform group-hover:scale-110 rounded-xl"
                      />
                    </div>
                  </NextLink>
                </div>
                <p class="mt-6 text-sm font-medium text-gray-500 dark:text-gray-100">
                  August 12, 2023
                </p>
                <p class="mt-4 text-xl font-bold leading-tight text-gray-900 dark:text-gray-50 xl:pr-8">
                  <NextLink
                    href="/blog/understanding-different-face-shapes"
                    class=""
                    title=""
                  >
                    How to Identify Your Face Shape? | Understanding Facial
                    Features
                  </NextLink>
                </p>{" "}
                <div class="mt-6">
                  <NextLink
                    href="/blog/understanding-different-face-shapes"
                    class="inline-flex items-center pb-2 text-xs font-bold tracking-widest text-gray-900 dark:text-gray-50 uppercase border-b border-gray-900 group dark:border-gray-50"
                    title=""
                  >
                    Continue Reading
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                      class="text-gray-900 dark:text-gray-50 w-4 h-4 ml-2 transition-all duration-200 transform group-hover:translate-x-1"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      ></path>
                    </svg>
                  </NextLink>
                </div>
              </div>    
            </div>         
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
};

export default HomePage;